import React, { CSSProperties } from 'react';

interface LotInfoProps {
  detailListStyle: CSSProperties,
  lotSizeArea: number | undefined,
  lotSizeAcres: number | undefined,
  parcelNumber: number | undefined,
}

const LotInfo = ({ detailListStyle, lotSizeArea, lotSizeAcres, parcelNumber }: LotInfoProps) => {
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-expand-arrows-alt me-2" />
        Lot Info
			</p>
			<ul style={detailListStyle}>
				{(lotSizeArea && lotSizeArea > 0) ? <li><span className="cc-font-weight--normal">Lot Size Area:</span> {lotSizeArea}</li> : ''}
				{(lotSizeAcres && lotSizeAcres > 0) ? <li><span className="cc-font-weight--normal">Lot Size Acres:</span> {lotSizeAcres}</li> : ''}
				{(lotSizeArea === 0 && lotSizeAcres === 0) ? <li><span className="cc-font-weight--normal">Lot size:</span> None listed</li> : ''}
				{parcelNumber && <li><span className="cc-font-weight--normal">Parcel Number:</span> {parcelNumber}</li>}
			</ul>
		</React.Fragment>
	);
};

export default LotInfo;